import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=b2fd6eba&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=b2fd6eba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fd6eba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2fd6eba')) {
      api.createRecord('b2fd6eba', component.options)
    } else {
      api.reload('b2fd6eba', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=b2fd6eba&scoped=true&", function () {
      api.rerender('b2fd6eba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pvE3tCw0uXYr/JS/comp/Voucher.vue"
export default component.exports